import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { UserServiceApiService } from './user-service-api.service'

@Injectable({
  providedIn: 'root',
})
export class MfaOnboardingService {
  public endpoint = 'v3/mfa_onboarding'

  constructor(
    private api: UserServiceApiService
  ) {
    // noop
  }

  public enable(): Observable<any> {
    const url = `${this.endpoint}/enable`
    return this.api.post<any>(
      url,
      {}
    ).pipe(
      map(response => response.result)
    )
  }

  public authenticatorAppCodes(): Observable<any> {
    const url = `${this.endpoint}/auth_app_qr_code`
    return this.api.get<any>(
      url,
      {
        headers: {
          'Accept': 'application/vnd.stat-ngin.v2,application/vnd.ngin-api.v2,application/json'
        }
      }
    ).pipe(
      map(response => {
        return response.result
      })
    )
  }

  public verifyOTP(code: string): Observable<any> {
    const url = `${this.endpoint}/verify_otp`
    return this.api.post<any>(
      url, 
      {
        'otp_attempt': code,
        'context': 'authenticator_app_onboarding'
      }
    ).pipe(
      map(response => response.result)
    )
  }

  public skip(): Observable<any> {
    const url = `${this.endpoint}/skip`
    return this.api.get<any>(
      url
    ).pipe(
      map(response => response.result)
    )
  }

  public complete(userReturnTo?: string): Observable<any> {
    const url = `${this.endpoint}/complete`
    const request = userReturnTo
      ? this.api.get<any>(url, { params: { user_return_to: userReturnTo } })
      : this.api.get<any>(url)

    return request.pipe(
      map(response => response.result)
    )
  }
}
